import * as yup from "yup";

import { radioValidator } from "../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = yup.object().shape({
  [ComponentId.IS_LEASE_CLIENT]: radioValidator,
  /*
  [ComponentId.VEHICLE_DRIVEABLE]: yup
    .string()
    .when(ComponentId.IS_LEASE_CLIENT, {
      is: "true",
      then: radioValidator,
    }),
    */
  [ComponentId.OC_TYPE]: yup.string().when([ComponentId.IS_LEASE_CLIENT], {
    is: (isLeasePlanClient: string) => isLeasePlanClient === "false",
    then: radioValidator,
  }),
});
